module.exports = __webpack_public_path__ + "img/bg_home_sm.223530c0.svg";